import React, { useState } from 'react'
import Select from 'react-select'
import { string } from 'prop-types'

function FastSelect({ value = '', name, ...rest }) {
  const [currentValue, setCurrentValue] = useState(value || '')

  return (
    <Select
      name={name}
      onChange={({ value: newValue, label }) => {
        setCurrentValue(newValue)
        window.getUrlWithSelected(name, newValue, label)

        if (name !== 'sort_by') {
          setCurrentValue('')
        }
      }}
      inputValue={currentValue}
      value={currentValue}
      isClearable={false}
      autoBlur
      {...rest}
    />
  )
}

FastSelect.propTypes = {
  name: string.isRequired,
  value: string,
}

export default FastSelect
